import { isLocalUrl } from '../utils';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
        $('.video-seo-container').addClass('no-seo');
      } else {
        createCustomSeo(data.items);
        $('.tier-three').css({
          display: 'block',
          opacity: '1',
        });
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      <a href="${URL}" class="button"  ${isLocalUrl(URL) ? '' : "target='_blank'"}>Learn More</a>
    `);

    animateTitle();
    animateDescription();
  }

  function animateTitle() {
    const $seoTitle = $('.seo-title');
    $seoTitle.css({
      opacity: 0,
      transform: 'translateY(20px)',
      visibility: 'hidden',
      transition: 'all 0.6s ease-out',
    });

    const observer = new IntersectionObserver(
      (entries, obs) => handleTitleIntersection(entries, obs, $seoTitle),
      { threshold: 0.5 },
    );

    observer.observe($seoTitle[0]);
  }

  function handleTitleIntersection(entries, obs, $seoTitle) {
    const entry = entries[0];
    if (entry.isIntersecting) {
      $seoTitle.css({
        opacity: 1,
        transform: 'translateY(0)',
        visibility: 'visible',
      });
      obs.unobserve($seoTitle[0]);
    }
  }

  function animateDescription() {
    const $seoDescription = $('.seo-description');
    if ($seoDescription.length) {
      const words = $seoDescription.text().split(' ');
      $seoDescription.empty();

      words.forEach((word) => {
        const $span = $('<span>')
          .text(word + ' ')
          .css({
            opacity: 0,
            visibility: 'hidden',
            transform: 'translateY(20px)',
            display: 'inline-block',
          });
        $seoDescription.append($span);
      });

      const observer = new IntersectionObserver(
        (entries, obs) => handleDescriptionIntersection(entries, obs, $seoDescription),
        { threshold: 0.5 },
      );

      observer.observe($seoDescription[0]);
    }
  }

  function handleDescriptionIntersection(entries, obs, $seoDescription) {
    const entry = entries[0];
    if (!entry.isIntersecting) return;

    $seoDescription.find('span').each((i, span) => {
      $(span).css({
        transition: `all 0.3s ease-out ${i * 0.1}s`,
        opacity: 1,
        visibility: 'visible',
        transform: 'translateY(0)',
      });
    });

    obs.unobserve($seoDescription[0]);
  }
}
